const SPACE_FROM_MOUSE = 20;

export default SPACE_FROM_MOUSE;
